<template>
    <!-- <div class='w-full lg:block transition-all duration-500 ease-in-out'
        :class='{
            "lg:max-w-[120px]": hideFilters,
            "lg:max-w-[308px]": !hideFilters
        }'
    > -->
    <div class="w-full lg:block transition-all duration-500 ease-in-out border-b border-grey-500 lg:border-0 overflow-hidden lg:min-h-full" v-if="page.defaults != null">
        <button
            class="lg:hidden h-14 bg-grey-300 w-full flex items-center justify-between pl-4 pr-2 z-50"
            @click="mobileFilters = !mobileFilters"
        >
            <p class="font-semibold text-15">{{ filtersLabel }}</p>

            <div class="w-10 flex items-center justify-center">
                <IconArrowDown class="h-5 w-5 stroke-black transition-all duration-500" :class="{ 'rotate-180': mobileFilters }" />
            </div>
        </button>

        <TransitionHeight
            :visable="mobileFilters"
            class="lg:!h-full lg:bg-white dark:lg:bg-transparent bg-grey-300 !overflow-visible"
            :class="{
                'lg:border-0 border-b border-grey-500': mobileFilters,
                'border-white': !mobileFilters,
            }"
        >
            <button class="items-center icon-hover w-full h-10 hidden lg:flex" @click="updateHideFilters">
                <h5 class="text-24 lg:text-28 font-bold font-hero">{{ filtersLabel }}</h5>

                <IconArrowDown
                    v-if="contentAbove"
                    :class="{ 'rotate-180': !page.user.page.filters }"
                    class="h-5 w-5 ml-3 stroke-black mt-0.5 hidden lg:block shrink-0 transition-all duration-500"
                />

                <IconArrowRight
                    v-else
                    :class="{ 'rotate-180': !page.user.page.filters }"
                    class="h-6 w-6 ml-3 mt-0.5 hidden lg:block shrink-0 transition-all duration-500"
                />
            </button>

            <slot name="below-label"></slot>

            <!-- lg:w-[308px] -->
            <form
                @submit.prevent="pageUpdate"
                ref="form"
                class="px-4 pt-2 lg:pt-0 lg:px-0 lg:opacity-0 transition-opacity duration-500 whitespace-nowrap"
                :class="{
                    'lg:opacity-100': !page.user.page.filters,
                    'lg:pt-8': !hasSearch
                }"
            >
            
                <div
                    class="flex items-center h-12"
                    v-if='hasSearch'
                    :class='{
                        "lg:mt-6 border-t border-grey-500": !!$slots["below-label"],
                        "lg:mt-6": !!$slots["below-label"] == false,
                    }'
                    v-tippy="{
                        content: page.lang.searchTooltipDescription,
                        placement: 'bottom-start',
                        maxWidth: '295px',
                    }"
                >
                    <IconSearch
                        class="h-6 w-6 shrink-0 transition-colors duration-300"
                        :class="[searchingInput ? 'stroke-black' : 'stroke-grey-800']"
                    />

                    <div class="w-full pl-3">
                        <input
                            type="text"
                            :placeholder="page.lang.searchPlaceholder ? page.lang.searchPlaceholder : 'Search ' + dataName + 's'"
                            name="search"
                            @keyup="$help.delay(() => search($event), 300)"
                            @focus="searchingInput = true"
                            @blur="searchingInput = false"
                            v-model="page.search"
                            class="placeholder-grey-900 text-16 lg:text-15 focus:outline-none cursor-pointer shrink-0 grow-1 w-full bg-transparent rounded-none"
                        />
                    </div>

                    <button class="" v-if="page.search != ''" @click="clearSearchInputValue">
                        <IconClose class="h-4 w-4 shrink-0 transition-colors duration-300 stroke-black" />
                    </button>
                </div>

                <div>
                    <Dropdown
                        position="relative"
                        class="border-t border-grey-500"
                        :allowClickOutSide="false"
                        v-if="page.defaults != null && page.defaults.filters.filter((f) => !f.required).length > 0"
                    >
                        <template #button="{ open }">
                            <div class="flex items-center justify-between h-16">
                                <p class="text-15 font-semibold">Edit filters</p>

                                <IconArrowDown
                                    class="h-5 w-5 stroke-black transition-all duration-500 mr-0.5"
                                    :class="{ 'rotate-180': open }"
                                />
                            </div>
                        </template>

                        <template #menu>
                            <div class="pb-4 flex flex-wrap -mx-1" v-if="page.defaults != null && page.defaults.filters != null">
                                <!-- <p v-if='page.user.filters["invoice"]' class="text-15 px-1 text-grey-900">Filters are restricted in invoice view.</p> -->

                                <template v-for="filter in page.defaults.filters.filter(f => Object.keys(f && f.values ? f.values : {}).length > 1)">
                                    <div
                                        v-tippy="{
                                            content: 'Subscribe to Zapo CRM to use this feature',
                                            delay: (!filter.crm_required || (filter.crm_required && $authSanctum.getUser().can())) ? 1000000 : 0
                                        }"
                                    >
                                        <div class='w-fit'
                                            v-tippy="{
                                                content: 'This filter is disabled in invoice view',
                                                placement: 'right',
                                                delay: page.hiddenFilters.includes(filter.name) ? 0 : 1000000
                                            }"
                                        >
                                            <button
                                                v-if="filter == undefined || (!filter.required && filter.selectable)"
                                                type='button'
                                                @click="!filter.required && toggleFilter(filter)"
                                                class="block border rounded-16 px-3 h-8 text-14 leading-7 pt-px grow-0 shrink-0 mx-1 my-1 hover:cursor-pointer disabled:bg-grey-400 disabled:border-grey-400 disabled:cursor-not-allowed disabled:text-grey-900"
                                                :disabled="(filter.crm_required && !$authSanctum.getUser().can()) || page.hiddenFilters.includes(filter.name)"
                                                :class="{
                                                    'text-green-600 border-green-600 bg-green-400/10': page.user.filters[filter.name] !== undefined,
                                                    'text-grey-900 border-grey-500': page.user.filters[filter.name] == undefined,
                                                }"
                                                v-text="filter.title"
                                            />
                                        </div>
                                    </div>
                                </template>

                                <template v-for="filter in page.manualFilters">
                                    <button
                                        @click="toggleFilter(filter)"
                                        class="block border rounded-16 px-3 h-8 text-14 leading-7 pt-px grow-0 shrink-0 mx-1 my-1 cursor-pointer"
                                        :class="[
                                            page.user.filters[filter.name] !== undefined
                                                ? 'text-green-600 border-green-600 bg-green-400/10'
                                                : 'text-grey-900 border-grey-500',
                                        ]"
                                        v-text="filter.title"
                                    />
                                </template>
                            </div>
                        </template>
                    </Dropdown>
                </div>

                <div class="" v-if="!!$slots['filters-above']">
                    <slot name="filters-above" :activeFilters />
                </div>

                <div class="pt-6 pb-6 border-t border-grey-500" v-for="filter in searchFilters">
                    <ContactFilter
                        :filter="filter"
                        :lContactId="page.user.filters[filter.name]"
                        @update="
                            (v) => {
                                page.user.filters[filter.name] = v
                                pageUpdate()
                            }
                        "
                    />
                </div>

                <Filter :title="'Order '+$help.pluralize(dataName, dataLength)+' by'"
                    :orderKey="page.user.orderBy.key"
                    :values='page.user.orderBy.value'
                    :order='page.defaults.orderBy'
                    :page='page'
                    v-if="page.defaults != null && page.defaults.orderBy != null && page.defaults.orderBy.length > 0"
                >
                    <template v-for="order in page.defaults.orderBy">
                        <label class="flex items-center cursor-pointer py-2">
                            <input
                                type="radio"
                                :value="order.name"
                                v-model="page.user.orderBy.key"
                                class="input-checkbox"
                                @change="pageUpdate"
                            />
                            
                            <span class="text-14 ml-3 shrink-0">{{ order.name }}</span>
                        </label>

                        <template v-if="page.user.orderBy.key == order.name">
                            <label v-for="(name, o) in order.values" class="flex items-center cursor-pointer py-2 pl-8">
                                <input
                                    type="radio"
                                    class="w-4.5 h-4.5 appearance-none border-2 border-grey-700 rounded-full checked:border-green-600 cursor-pointer checked:border-7 shrink-0"
                                    :value="o"
                                    v-model="page.user.orderBy.value"
                                    @change="pageUpdate"
                                />

                                <span class="text-14 ml-3 shrink-0">{{ name }}</span>
                            </label>
                        </template>
                    </template>
                </Filter>

                <div v-if="page.user != null && page.user.filters != null">
                    <!-- {{page?.user?.filters }} -->
                    <!-- <template v-if='page?.user?.filters.length > 0' v-for="filter in page.user.filters">
                        {{ filter  }}
                        <div>
                            <p class="text-17 font-semibold pb-3">{{ filter.title }}</p>
                        </div>
                    </template> -->

                    <!-- <div v-for='filter in page.manualFilters'>
                        <template v-if="page.user.filters[filter.name] !== undefined">
                            <div class="pt-6 pb-6 border-t border-grey-500" >
                                <p class="text-17 font-semibold pb-3">{{ filter.title }}</p>

                                <template v-if="filter.type == 'select' && filter.manual">
                                    <Select :options='filter.values.map((v) => ({ html: v.ads_period_from + " " + v.ads_period_to, value: v.id }))' 
                                        @update:value="($event) => filter.change($event)"
                                    />
                                </template>
                            </div>
                        </template>
                    </div> -->

                    <div class="pt-6 pb-6 border-t border-grey-500" v-if="page.user.filters['date_range'] !== undefined 
                        && !page.hiddenFilters.includes('date_range')">

                        <div class="flex items-center justify-between pb-3">
                            <p class="text-17 font-semibold">Date range</p>
                            <button class="text-14 link-text text-purple-600 underline pt-1" type='button' 
                                v-if='page.defaults.filters.find(f => f.name == "invoice") !== undefined'
                                @click='(removeInvoiceFilter(page.defaults.filters.find(f => f.name == "invoice")))'
                            >View invoices</button>
                        </div>

                        <InputDropdownDatePicker
                            label="Start date"
                            :value="$moment(page.user.filters['date_range'][0])"
                            @update:value="setDateRangeFilter('date_range', [$event, page.user.filters['date_range'][1]])"
                            emitFormat="YYYY-MM-DD"
                        />

                        <InputDropdownDatePicker
                            label="End date"
                            class="mt-4"
                            :value="$moment(page.user.filters['date_range'][1])"
                            @update:value="setDateRangeFilter('date_range', [page.user.filters['date_range'][0], $event])"
                            emitFormat="YYYY-MM-DD"
                            :min="$moment(page.user.filters['date_range'][0]).format('YYYY-MM-DD')"
                        />
                    </div>

                    <template v-for="filter in activeFilters">
                        <!-- <template v-if="true"> -->
                        <Filter :title="filter.title"
                            :values='page.user.filters[filter.name]'
                            :filter v-if="filter.type != 'toggle'"
                            :page='page'
                        >
                            <template v-if='filter.type == "checkbox"' #buttons>
                                <button class='text-13 underline hover:text-black hover:no-underline text-grey-900 cursor-pointer transition-all' 
                                    type='button' @click='selectAll(filter)'>Select all</button>, 

                                <button class='text-13 underline hover:text-black hover:no-underline text-grey-900 cursor-pointer transition-all' 
                                    type='button' @click='unselect(filter)'>Unselect all</button>
                            </template>

                            <!-- <div class="pt-6 pb-6 border-t border-grey-500"> -->
                                <!-- <div class="flex items-center justify-between pb-3">
                                    <p class="text-17 font-semibold">{{ filter.title }}</p>
                                    <button class="text-14 link-text text-purple-600 underline pt-1" type='button' 
                                        v-if='filter.type == "invoice_period"'
                                        @click='removeInvoiceFilter(filter)'
                                    >View date range</button>
                                </div> -->

                                <!-- v-if="page.user.filters['location'] !== undefined" -->
                                <ProspectLocationAreaFilter :areas='page.defaults.filters.find(f => f.name == filter.name)'
                                    :value="page.user.filters[filter.name]"
                                    :page='page' 
                                    v-if="filter.type == 'prospect_location_area'"   
                                />

                                <template v-if="filter.type == 'invoice_period'">
                                   <InvoiceFilter :filter='filter' :page='page' />
                                </template>

                                <template v-if="filter.type == 'radio'">
                                    <label class="flex items-center cursor-pointer py-2" v-for="(name, value) in filter.values">
                                        <input
                                            type="radio"
                                            :name="filter.name"
                                            v-model="page.user.filters[filter.name]"
                                            :value="value"
                                            @change="pageUpdate"
                                            class="w-4.5 h-4.5 appearance-none border-2 border-grey-700 rounded-full checked:border-green-600 checked:border-7 cursor-pointer shrink-0"
                                        />

                                        <span class="text-14 ml-2 shrink-0">{{ name }}</span>
                                    </label>
                                </template>

                                <template v-if="filter.type == 'checkbox'">
                                    <template v-for="(name, value) in filter.values">
                                        <div class='w-fit'
                                            v-tippy="{
                                                content: 'This filter is disabled in invoice view',
                                                placement: 'right',
                                                delay: page.hiddenFilters.includes(filter.name) ? 0 : 1000000
                                            }"
                                        >
                                            <label class="flex items-center cursor-pointer py-2 w-fit" v-if="typeof name === 'string'"
                                                v-tippy="{
                                                    content: 'Subscribe to Zapo CRM to use this feature',
                                                    placement: 'right',
                                                    delay: ((filter.values_crm_required.indexOf(value) == -1) || (filter.values_crm_required.length > 0 && filter.values_crm_required.indexOf(value) > -1 && $authSanctum.getUser().can())) ? 1000000 : 0
                                                }"
                                                :class="{
                                                    'text-grey-800 cursor-not-allowed': (filter.values_crm_required.length > 0 && filter.values_crm_required.indexOf(value) > -1 && !$authSanctum.getUser().can())
                                                        || page.hiddenFilters.includes(filter.name)
                                                }"
                                            >
                                                <input
                                                    type="checkbox"
                                                    :name="filter.name + '[]'"
                                                    :value="isNaN(value) ? value : parseInt(value)"
                                                    v-model="page.user.filters[filter.name]"
                                                    @change="pageUpdate"
                                                    class="input-checkbox disabled:!opacity-20 mr-3"
                                                    :disabled="(filter.values_crm_required.length > 0 && filter.values_crm_required.indexOf(value) > -1 && !$authSanctum.getUser().can()) || page.hiddenFilters.includes(filter.name)"
                                                />

                                                <component :is="filter.icons[value] + (page.hiddenFilters.includes(filter.name) ? 'Grey' : '')" 
                                                    class="w-4 h-4 shrink-0 mr-2" v-if="filter.icons != null" 
                                                />

                                                <span class="text-14 shrink-0">{{ name }}</span>
                                            </label>

                                            <label class="flex items-center cursor-pointer py-2" v-else>
                                                <input
                                                    type="checkbox"
                                                    :name="filter.name + '[]'"
                                                    :value="isNaN(name[0]) ? name[0] : parseInt(name[0])"
                                                    v-model="page.user.filters[filter.name]"
                                                    @change="pageUpdate"
                                                    class="input-checkbox"
                                                />

                                                <span class="text-14 ml-3 shrink-0">{{ name[1] }}</span>
                                            </label>
                                        </div>
                                    </template>
                                </template>

                                <!-- <div v-if='filter.type == "date_range"'>
                                <Calendar :showInputs='true'
                                    :range='true'
                                    :startsAt='$moment(page.user.filters[filter.name][0]).format("Do MMMM YYYY")'
                                    :endsAt='$moment(page.user.filters[filter.name][1]).format("Do MMMM YYYY")'
                                    @updatedPayload='setDateRangeFilter("date_range", $event)'
                                />
                            </div> -->

                                <div
                                    v-if="page.errors != undefined && page.errors['filters.' + filter.name] != null"
                                    class="text-error text-14 pt-2 flex items-center"
                                >
                                    <IconFalse class="w-5 h-5 stroke-red-700 bg-red-700 rounded-full bg-opacity-10 mr-2" />
                                    <p>{{ page.errors['filters.' + filter.name][0] }}</p>
                                </div>
                            <!-- </div> -->
                        <!-- </template> -->
                        </Filter>
                    </template>
                </div>
            </form>

            <div class="border-b border-grey-500 mx-4 block lg:hidden" />

            <button
                class="lg:hidden h-14 bg-grey-300 w-full flex items-center justify-between px-4 z-50 block lg:hidden"
                @click="mobileFilters = !mobileFilters"
            >
                <p class="font-semibold text-15">Close filters</p>
                <IconArrowDown
                    class="h-5 w-5 stroke-black transition-all duration-500 mr-0.5"
                    :class="{ 'rotate-180': mobileFilters }"
                />
            </button>
        </TransitionHeight>
    </div>
</template>

<script>
import ContactFilter from '~/components/customer/table/filters/contact-search.vue'
import InvoiceFilter from '~/components/customer/table/filters/invoice-filter.vue'
import ProspectLocationAreaFilter from '~/components/customer/table/filters/prospect-location-area.vue'
import Filter from '~/components/customer/table/filters/filter.vue';

export default {
    props: {
        page: Object,
        // page.defaults: Object,
        // page.user: Object,
        // errors: Object,
        dataName: String,
        contentAbove: [Boolean, Array],
        dataLength: Number,
        hasSearch: { type: Boolean, default: true },
        filtersLabel: { type: String, default: 'Filters' }
    },

    data() {
        return {
            mobileFilters: false,
            blackout: null,
            query: '',
            searchingInput: false,
            searchInputValue: '',
            filter: null,
        }
    },

    mounted() {
        // this.$smoothElement({
        //           el: this.$refs.filtersMobileMenu,
        //           transition: 'height .3s'
        //       })
    },

    methods: {
        updateHideFilters() {
            this.$emit('update:filters', !this.page.user.page.filters)
        },

        search(e) {
            // if (this.page.search == e.target.value) {
            //  this.page.set('updating', false)
            //  return false;
            // }

            // this.page.set('updating', true)

            this.$help.delay(() => {
                this.page.set('search', e.target.value).updated()
            }, 150)
        },

        toggleFilter(filter) {
            // this.$event.$emit('page-toggle-filter', filter);
            this.page.call().toggleFilter(filter)
        },

        removeInvoiceFilter(filter) {
            this.page.call().removeFilter(this.page.defaults.filters.find(f => f.name == 'lead_source'))
            this.page.call().removeFilter(this.page.defaults.filters.find(f => f.name == 'trade'))
            this.page.call().removeFilter(this.page.defaults.filters.find(f => f.name == 'location'))
            this.page.call().removeFilter(this.page.defaults.filters.find(f => f.name == 'company_id'))
            this.page.call().removeFilter(this.page.defaults.filters.find(f => f.name == 'product'))
            this.page.call().toggleFilter(filter)
        },

        toggleBlackout() {
            // if (! this.mobileFilters) {
            // this.blackout = document.createElement("div");
            // this.blackout.classList
            //  .add('bg-black/70', 'absolute', 'inset-0', 'block')
            // this.blackout.style.top = '120px';
            // document.body.appendChild(this.blackout);
            // document.body.style.overflow = 'hidden';
            // }
        },

        setDateRangeFilter(key, pay) {
            this.page.user.filters[key] = pay
            this.page.call().updated()
        },

        pageUpdate() {
            // this.$event.$emit("page-update")
            this.page.set('preUpdate', true)

            // this.$help.delay(() => {
                this.page.call().updated()  
            // }, 800)
        },

        clearSearchInputValue() {
            this.page.search = ''
            this.page.set('search', '').updated()

            // setTimeout(() => {
            //  this.page.call().updated()
            // }, 200)
        },

        selectAll(filter) {
            let values = [];

            for (let value in filter.values) {
                values.push(value);
            }

            this.page.user.filters[filter.name] = values;
            this.page.call().updated()
        },

        unselect(filter) {
            // console.log(filter)
            this.page.user.filters[filter.name] = [];
            this.page.call().updated()
        }
    },

    watch: {
        // page.user() {
        //  this.hideFilters = this.page.user.page.filters;
        // },

        mobileFilters() {
            this.toggleBlackout()
        },
    },

    computed: {
        activeFilters() {
            let temp = this.page.defaults.filters.filter((f) => {
                return this.page.user.filters[f.name] !== undefined && f.name != 'date_range' && f.type != 'search' && f.hidden == false
                    && Object.keys(f.values).length > 1
            })

            temp = temp.sort((a, b) => {
                if (a.order !== null && b.order !== null) {
                    return a.order - b.order;
                } else if (a.order === null && b.order !== null) {
                    return 1;
                } else if (a.order !== null && b.order === null) {
                    return -1;
                } else {
                    return a.name.localeCompare(b.name);
                }
            })

            return temp
        },

        searchFilters() {
            // console.log(this.page.user.filters)
            return this.page.defaults.filters.filter((f) => {
                if (f.name == 'contactId') {
                    // console.log(f)
                }
                return this.page.user.filters[f.name] !== undefined && f.type == 'search' && f.hidden == false
            })
        },

        invoiceOverride() {
            return this.page.user.filters["invoice"]
        }
    },

    components: {
        // 'TransitionHeight': require('~/components/customer/transitions/height').default,
        // 'Calendar': require('~/components/customer/misc/calendar').default,
        ContactFilter,
        InvoiceFilter,
        ProspectLocationAreaFilter,
        Filter
    },
}
</script>
